import { useEffect, type FC } from "react";

interface RedirectProps {
  to: string;
}

export const Redirect: FC<RedirectProps> = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center min-h-[60vh] gap-6 animate-fade-in"
    >
      <div
        className="w-16 h-16 border-4 border-jakala-red border-t-transparent rounded-full animate-spin motion-reduce:animate-none"
        aria-hidden="true"
      />
      <p className="text-white text-xl font-semibold">Redirigiendo...</p>
    </div>
  );
};

export default Redirect;
